export const getOpenapiSchemaMessage = {
  error: 'Failed to load openapi schema',
};
